// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import Tooltip from "@steiner/MobiusOverrides/Tooltip";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsManufacturingPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const manufacturingPartNumberStyles: ProductDetailsManufacturingPartNumberStyles = {
    labelText: {
        size: 16,
        weight: "bold",
        css: css`
            margin-right: 15px;
        `,
    },
    valueText: {
        size: 16,
        css: css`
            margin-bottom: 5px;
        `,
    },
};

const styles = manufacturingPartNumberStyles;

const ProductDetailsManufacturingPartNumber: React.FC<Props> = ({ product }) => {
    if (!product.manufacturerItem) {
        return null;
    }
    return (
        <Typography {...styles.valueText} as="p">
            {/* XNG-Change */}
            {/* Change label text from MFG # to MFGR # */}
            {/* Use Tootlip */}
            <Typography {...styles.labelText}>{translate("MFGR #")}</Typography>
            {product.manufacturerItem.length > 35 ? (
                <Tooltip
                    text={product.manufacturerItem}
                    triggerComponent={
                        <Typography>
                            {product.manufacturerItem.substring(0,35)}...
                        </Typography>
                    }
                />
            ) :
                product.manufacturerItem
            }
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsManufacturingPartNumber),
    definition: {
        displayName: "Manufacturing Part Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
